import { boolean, InferType, number, object, string } from "yup";

export const assistantEditValidationSchema = object({
  workflowId: string().required("Workflow ID is required"),
  workflowVersion: string().required("Workflow Version is required"),
  limits: object({
    basic: object({
      enabled: boolean().required(),
      maxProperties: number()
        .min(0, "Must be 0 or greater")
        .required("Max Properties is required"),
      maxRowsPerScope: number()
        .min(0, "Must be 0 or greater")
        .required("Max Rows Per Scope is required"),
    }),
    pro: object({
      enabled: boolean().required(),
      maxProperties: number()
        .min(0, "Must be 0 or greater")
        .required("Max Properties is required"),
      maxRowsPerScope: number()
        .min(0, "Must be 0 or greater")
        .required("Max Rows Per Scope is required"),
    }),
    team: object({
      enabled: boolean().required(),
      maxProperties: number()
        .min(0, "Must be 0 or greater")
        .required("Max Properties is required"),
      maxRowsPerScope: number()
        .min(0, "Must be 0 or greater")
        .required("Max Rows Per Scope is required"),
    }),
  }),
});

export type TAssistantEditValidationSchema = InferType<
  typeof assistantEditValidationSchema
>;
